export const alphaNumericRegEx = '[a-zA-Z0-9 ]*$'; // alpha numeric with spaces
export const alphaNumericWithSpecialCharsRegEx = '[a-zA-Z0-9 -.’]*$'; // alpha numeric with spaces
